export default "/images/maximize.svg?a19fddf606666899fbe127b0ed8377e9";